import React, { useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Section from './Section';
import IconButton from '../../components/common/IconButton';

const DragContainer = styled.p`
  border: solid 1px grey;
  border-radius: 10px;
  width: 120px;
  height: 120px;
  line-height: 120px;
  background-color: lightgray;
  text-align: center;

  &:active, &:hover, &:-moz-drag-over {
    border: solid 2px black;
    background-color: #fff;
  }
`;

const DragGalleryContainer = styled.div`
  width: 122px;
  height: 122px;
  border: 1px solid lightgray;
  border-radius: 5px;
  display: table-cell;
  padding: 5px;
`;

function InstructionGeneratorAdd (props) {
  const [universalFormArray, setUniversalFormArray] = useState([<Section/>]);
  const [universalFormArrayLength, setUniversalFormArrayLength] = useState(universalFormArray.length);
  const deleteUniversalForm = (index) => {
    console.log('index');
    console.log(index);
    let tmp = universalFormArray;
    console.log('universalFormArray bef')
    console.log(universalFormArray)
    tmp.splice(index, 1);
    setUniversalFormArray(tmp);
    setUniversalFormArrayLength(tmp.length);
    console.log('universalFormArray after')
    console.log(tmp)

  };

  const addUniversalForm = () => {
    let tmp = universalFormArray;
    tmp.push((<Section />));
    setUniversalFormArray(tmp);
    setUniversalFormArrayLength(tmp.length)
  }

  return (
    <div>
      {universalFormArrayLength}
      {
        universalFormArray.map((form, index) => (
          <div style={{ backgroundColor: 'lightgray', border: '1px solid #000', margin: 3 }}>
            <span style={{ cursor: 'pointer' }} onClick={() => deleteUniversalForm(index)}>X</span>
            {form}
          </div>
        ))
      }
      <IconButton wide marginBottom title="Add section" style={{ width: '90px', height: '34px' }} onClick={addUniversalForm}/>
    </div>
  );
}

function mapStateToProps ({ filesWidgetReducer }) {
  return {
    ...filesWidgetReducer
  };
}

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};
export default connect(mapStateToProps, mapDispatchToProps)(InstructionGeneratorAdd);
